export const RADIO_FRONT_PATH = 'radio-front';
export const EPISODES_PATH = 'episodes';
export const INFO_PATH = 'info';
export const ITEMS_PATH = 'items';
export const SEARCH_PATH = 'search';
export const SETTINGS_PATH = 'settings';
export const SIMILAR_PATH = 'similar';
export const LOGIN_PATH = 'login';
export const LOGIN_ONBOARDING_PATH = 'login-onboarding';
export const PROFILES_PATH = 'profiles';
export const CONSENT_PATH = 'consent';
export const PLAYER_PATH = 'player';
export const BRAZE_INAPP_MESSAGE = 'message';
export const ADD_USER_PATH = `${PROFILES_PATH}/add-user`;
export const ADD_SUB_PROFILE_PATH = `${ADD_USER_PATH}/sub-profile`;
export const TOS_PATH = 'tos';
export const TESTS_PATH = 'tests';
export const TEST_PLAYER_PATH = 'player';
export const PACKAGES_PATH = 'packages';
export const LIVE_PATH = 'live';
export const FAVORITES_PATH = 'omat';
export const DEVICE_INFO_PATH = 'device-info';
export const ERROR_PATH = 'error';
export const HOME_PATH = 'home';

export const PAIR_LOGIN_SUB_PATH = 'pair';
export const CREDENTIALS_LOGIN_SUB_PATH = 'credentials';
export const REGISTER_LOGIN_SUB_PATH = 'register';
export const SESSION_EXPIRED_PATH = 'error-expired-session';
export const NOT_FOUND_PATH = 'not-found';
